'use client';

import type {Strings} from '../library/types';
import type {Locale} from '../../i18n.config';
import Link from 'next/link';
import Container from './Container';
import MenuIcon from '../assets/icons/menu.svg';
import Backdrop from './Backdrop';
import HeaderLink from './HeaderLink';
import {localizePath} from '../library/languages';
import {useState} from 'react';

type Props = {
  locale: Locale;
  strings: Strings;
  floating?: boolean;
};

export default function Header({locale, strings, floating = false}: Props) {
  const [visible, setVisible] = useState(false);

  const headerTheme = floating ? 'absolute' : 'bg-gray-950';
  const navTheme = visible ? 'flex' : 'hidden md:flex';

  function toggleMenu() {
    setVisible((oldState) => !oldState);
  }

  function closeMenu() {
    setVisible(false);
  }

  return (
    <header className={`z-30 h-header w-full text-white ${headerTheme}`}>
      <Container>
        <nav className="flex flex-row items-center py-4">
          <Link
            href={localizePath('/', locale)}
            className="mr-auto text-2xl font-extrabold">
            Squadnox
          </Link>
          <button
            onClick={() => toggleMenu()}
            className="md:hidden"
            aria-label={strings.header.toggle}>
            <MenuIcon className="w-10" />
          </button>
          <Backdrop visible={visible} onClick={() => toggleMenu()} />
          <div
            className={`fixed right-0 top-0 z-20 m-6 flex-col rounded-lg bg-white py-2 text-2xl text-gray-700 shadow-md md:relative md:m-0 md:flex-row md:space-x-6 md:rounded-none md:bg-transparent md:p-0 md:text-lg md:text-current md:shadow-none ${navTheme}`}>
            <HeaderLink
              href={localizePath('/games', locale)}
              onClick={closeMenu}>
              {strings.header.games}
            </HeaderLink>
            <HeaderLink
              href={localizePath('/guides', locale)}
              onClick={closeMenu}>
              {strings.header.guides}
            </HeaderLink>
            <HeaderLink
              href={localizePath('/blog', locale)}
              onClick={closeMenu}>
              {strings.header.blog}
            </HeaderLink>
            <HeaderLink href={localizePath('/faq', locale)} onClick={closeMenu}>
              {strings.header.faq}
            </HeaderLink>
            <HeaderLink
              href={localizePath('/support', locale)}
              onClick={closeMenu}>
              {strings.header.support}
            </HeaderLink>
          </div>
        </nav>
      </Container>
    </header>
  );
}
